module.exports = __webpack_public_path__ + "media/step_3_da.5cc3b401.mp3";